import Ctasection from "./lemolite/Ctasection";
import Footer from "./lemolite/Footer";
import Lemobanner from "./lemolite/Lemobanner";
import Lemoheader from "./lemolite/Lemoheader";
import TailoredSolutions from "./lemolite/Tailoredsolutions";
import Visionandexpertise from "./lemolite/Visionandexpertise";


const IdleResumePanel = ({ onResume }: { onResume?: () => void }) => {
  const solutions = [
  {
    title: "Custom Software Development",
    description:
      "We build tailored software solutions that align with your business goals for seamless, high-performance results.",
    link: "https://lemolite.com/services/custom-software-development",
  },
  {
    title: "Web Development",
    description:
      "Our professional web developers will turn your ideas into high-performance, responsive web apps.",
    link: "https://lemolite.com/services/web-development",
  },
  {
    title: "UI/UX Design",
    description:
      "Our expert designers are ready to develop an amazing user experience for your project.",
    link: "https://lemolite.com/services/ui-ux-design",
  },
  {
    title: "Intelligent Automation",
    description:
      "Transform your business processes with our comprehensive AI, machine learning, and IoT solutions.",
    link: "https://lemolite.com/services/ai-ml-development",
  },

];
const services = [
  { title: "Manufacturing", img: "/manufacring.png" },
  { title: "Ecommerce", img: "/ecommers.png" },
  { title: "Healthcare", img: "/helthcare.png" },
  { title: "Banking & Finance", img: "/banking.png" },
  { title: "Agriculture", img: "/agricaltaure.png" },
  { title: "Education", img: "/education.png" },
  { title: "Energy & Utilities", img: "/energy.png" },
  { title: "Hospitality", img: "/hospitality.png" },
  { title: "Automobile", img: "/automobile-small.svg" },
];

  return (
    <>
        <Lemoheader />
        <Lemobanner onImageClick={onResume} />
        <TailoredSolutions solutions={solutions} />
        <Ctasection
        title={"Ready to Transform Your Business?"}
        text={"Take the First Step Today"}
        link={"https://lemolite.com/contact-us"}
        image="/ctagreadiant.webp"
        bg="bg-[#F1F1F1]"
      />
        <Visionandexpertise
        title="Your Vision, Our Expertise!"
        content="We provide tailored custom software development services to drive innovation, improve efficiency, enhance customer experience, and support digital transformation, helping you achieve success and stay competitive."
        service={services}
      />
          <Footer />
    </>
 
  );
};

export default IdleResumePanel;
